document.addEventListener("DOMContentLoaded", function() {
    const hydrocolloidRatios = {
        agar: { light: 0.5, medium: 1.0, firm: 2.0 },
        xanthan: { light: 0.1, medium: 0.3, firm: 0.5 },
        guar: { light: 0.3, medium: 0.6, firm: 1.0 },
        carrageenan: { light: 0.2, medium: 0.8, firm: 1.5 },
        gelatin: { light: 1.0, medium: 2.5, firm: 5.0 }
    };

    function calculateAmount() {
        let volume = document.getElementById("volume").value;
        let hydrocolloid = document.getElementById("hydrocolloid").value;
        let strength = document.getElementById("strength").value;

        if (!volume || volume <= 0) {
            alert("Please enter a valid liquid volume.");
            return;
        }

        let ratio = hydrocolloidRatios[hydrocolloid][strength];
        let grams = (volume * ratio) / 100;

        let resultDiv = document.getElementById("result");
        resultDiv.innerHTML = `<p><strong>Use ${grams.toFixed(2)} grams of ${hydrocolloid}.</strong></p>`;

        // Add Return to Home button
        let homeButton = document.createElement("button");
        homeButton.textContent = "Return to Home Page";
        homeButton.style = "display: block; margin: 20px auto; padding: 10px 15px; background: #FF7E00; color: white; border: none; border-radius: 5px; cursor: pointer;";
        homeButton.onclick = function() {
            window.location.href = "/";
        };

        resultDiv.appendChild(homeButton);
    }

    document.getElementById("hydrocolloid-calculator").innerHTML = `
        <div style="padding: 20px; border: 1px solid #ddd; border-radius: 8px; max-width: 400px; margin: auto; background-color: #f9f9f9;">
            <h2 style="text-align: center;">Hydrocolloid Usage Calculator</h2>
            <label>Liquid Volume (ml):</label>
            <input type="number" id="volume" style="width: 100%; padding: 5px; margin-bottom: 10px;">

            <label>Hydrocolloid Type:</label>
            <select id="hydrocolloid" style="width: 100%; padding: 5px; margin-bottom: 10px;">
                <option value="agar">Agar</option>
                <option value="xanthan">Xanthan Gum</option>
                <option value="guar">Guar Gum</option>
                <option value="carrageenan">Carrageenan</option>
                <option value="gelatin">Gelatin</option>
            </select>

            <label>Desired Strength:</label>
            <select id="strength" style="width: 100%; padding: 5px; margin-bottom: 10px;">
                <option value="light">Light</option>
                <option value="medium">Medium</option>
                <option value="firm">Firm</option>
            </select>

            <button id="calculate-btn" style="width: 100%; padding: 10px; background: #28a745; color: white; border: none; border-radius: 5px; cursor: pointer;">
                Calculate
            </button>

            <div id="result" style="text-align: center; font-weight: bold; margin-top: 15px;"></div>
        </div>
    `;

    document.getElementById("calculate-btn").addEventListener("click", calculateAmount);
});
